import { useWindowSizeStore } from "@biom3/react";
import { useMemo } from "react";

export const LARGE_VERTICAL_BREAKPOINT = 500 as const;
export const SMALL_VERTICAL_BREAKPOINT = 300 as const;

export function useIsLandscapeDisplayMode(
  verticalBreakpoint:
    | typeof LARGE_VERTICAL_BREAKPOINT
    | typeof SMALL_VERTICAL_BREAKPOINT,
) {
  const { state: windowHeight } = useWindowSizeStore((state) => state.height);

  const isLandscapeDisplayMode = useMemo(() => {
    if (windowHeight === null) return false;
    return windowHeight < verticalBreakpoint;
  }, [windowHeight, verticalBreakpoint]);
  return isLandscapeDisplayMode;
}
